// import config from '@/config';
import config from "../config";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || config.API_BASE_URL;
export const CLOUDINARY_UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
export const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
